import { apiFetch } from './base';
import type { AvailabilityResponse } from './types';

export function fetchAvailability(checkin: string, checkout: string) {
  return apiFetch<AvailabilityResponse>(`/api/availability?checkin=${checkin}&checkout=${checkout}`);
}

export function fetchBookedRoomIds(checkin: string, checkout: string) {
  return apiFetch<{ booked: number[] }>(`/api/availability/booked?checkin=${checkin}&checkout=${checkout}`);
}

// Returns strapi_room_ids that have at least one free physical room.
// If a type has 0 rooms in the dashboard, it is excluded (not available).
export function fetchAvailableRoomTypes(checkin: string, checkout: string) {
  return apiFetch<{ available: number[] }>(`/api/availability/available-types?checkin=${checkin}&checkout=${checkout}`);
}

// Returns a status map per room type for the given dates.
// Possible values: 'available' | 'fully_booked' | 'maintenance'
// Missing from map = 'not_setup' (no physical rooms added in dashboard yet)
export function fetchRoomStatuses(checkin: string, checkout: string) {
  return apiFetch<{ statuses: Record<number, 'available' | 'fully_booked' | 'maintenance'> }>(
    `/api/availability/room-statuses?checkin=${checkin}&checkout=${checkout}`
  );
}
